export default "__VITE_ASSET__BQ4Vs4VR__"